
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkWorkflowActionsProjectEnum } from '../models/work-workflow-actions-project-enum';
import { requiredBoolean } from './required-boolean.validator';

export function getUpdateWorkflowProjectDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    action: new FormControl<WorkWorkflowActionsProjectEnum | undefined>(undefined, [Validators.required]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    projectWorkflow: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    containertypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      